export default __webpack_public_path__ + "static/media/thumbnail2.0fdba004.png";